import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { compose, withState, withActions } from "containers/HOC";
import Tile from "components/Tile";
import TileBody from "components/TileBody";
import PageTabs, { TAB } from "containers/BudgetHome/PageTabs";
import CatchmentDetails from "./CatchmentDetails";
import * as domain from "common/domain";
import { submitUnfencedWetland } from "./_actions";
import { v4 as uuidv4 } from "uuid";
import { modalInlineOpen, modalInlineClose } from "containers/App/_actions";

class CatchmentCreate extends Component {
    submit(wetland) {
        this.props.submitUnfencedWetland(this.props.farm.id, this.props.budget.id, wetland);
    }

    render() {
        const { farm, budget } = this.props;
        return (
            <Tile>
                <PageTabs farmId={farm.id} budget={budget} tab={TAB.WETLANDS} />
                <TileBody>
                    <CatchmentDetails farm={farm} budget={budget} wetland={this.props.wetland} refData={this.props.refData} location={this.props.location} showQuickTips={this.props.showQuickTips} toggleQuickTips={this.props.toggleQuickTips} isNew={true} isUnfenced={true} submitUnfenced={this.submit.bind(this)} history={this.props.history} modalInlineClose={this.props.modalInlineClose} modalInlineOpen={this.props.modalInlineOpen} />
                </TileBody>
            </Tile>
        );
    }
}

export default compose(
    withRouter,
    withState((state, ownProps) => {
        const wetland = domain.factoryWetland();
        wetland.id = uuidv4();
        return {
            ...ownProps,
            refData: state.app.refData,
            wetland: wetland,
        };
    }),
    withActions({ submitUnfencedWetland, modalInlineOpen, modalInlineClose })
)(CatchmentCreate);
